import React, {
    useMemo,
    useState,
    useEffect,
    useCallback,
    useRef,
} from "react";
import {
    Image,
    Row,
    Col,
    Button,
    Modal,
    Table,
    Alert,
} from "react-bootstrap";
import * as Icon from "react-bootstrap-icons";
import Select from "react-select";
import { getValuesAsList, getKeyByValue, OptionRenderer } from "../../utils"
import { ThreeCircles } from "react-loader-spinner";
import { v4 } from "uuid";
import OverlayTrigger from "react-bootstrap/OverlayTrigger";
import Popover from "react-bootstrap/Popover";
import { CygnusCustomMappingModal } from "./CygnusCustomMappingModal";

export function AddMappingModal(props) {
    let token = localStorage.getItem("token");
    const [sourceField, setSourceField] = useState();
    const [destinationField, setDestinationField] = useState();
    const [customSourceCheck, setCustomSourceCheck] = useState(false)
    const [customDestinationCheck, setCustomDestinationCheck] = useState(false)
    const [customFormatCheck, setCustomFormatCheck] = useState(false)
    const [customSourceField, setCustomSourceField] = useState("");
    const [customDestinationField, setCustomDestinationField] = useState("");
    const [fieldFormat, setFieldFormat] = useState("");
    const [apiInProgress, setApiInProgress] = useState(false);
    const [dataFields, setDataFields] = useState([{ "id": v4(), "source": "", "destination": "", "FirmVendorMappingId": v4() }]);
    const [showCustomMappingModal, setShowCustomMappingModal] = useState(false);

    const [sourceEndPoints, setSourceEndPoints] = useState(null)
    useEffect(() => {
        setSourceEndPoints(props.sourceEndPoints)
    }, [props.sourceEndPoints])

    const [targetEndPoints, setTargetEndPoints] = useState(null)
    useEffect(() => {
        setTargetEndPoints(props.targetEndPoints)
    }, [props.targetEndPoints])

    const [flowStepNumber, setFlowStepNumber] = useState({ label: "", value: 0 })

    const popover_1 = (
        <Popover id="popover-basic">
            <Popover.Header as="h6">Field mapping</Popover.Header>
            <Popover.Body>
                Select source application field to be mapped to a destination application field.
            </Popover.Body>
        </Popover>
    );

    const popover_2 = (
        <Popover id="popover-basic">
            <Popover.Header as="h6">Data mapping</Popover.Header>
            <Popover.Body>
                Customize data from source application field with custom value to be updated in destination application field.
            </Popover.Body>
        </Popover>
    );
    const saveDataMapping = () => {
        setApiInProgress(true)
        const finalDataFields = dataFields.filter(o => (o.source && o.destination));
        props.addDataMapping(sourceField, destinationField, customSourceCheck, customDestinationCheck, customFormatCheck, customSourceField, customDestinationField, fieldFormat, finalDataFields, flowStepNumber)
        setTimeout(() => {
            setApiInProgress(false)
            setDataFields([{ "id": v4(), "source": "", "destination": "", "FirmVendorMappingId": v4() }])
            setSourceField("")
            setDestinationField("")
            setCustomSourceCheck(false)
            setCustomDestinationCheck(false)
            setCustomFormatCheck(false)
            setCustomSourceField("")
            setCustomDestinationField("")
            setFieldFormat("")
            setFlowStepNumber({ label: "", value: 0 })
        }, 2000);
    }
    const updateCustomDataField = (event, flag) => {
        if (flag === "source") {
            setCustomSourceField(event.target.value)
        } else if (flag === "destination") {
            setCustomDestinationField(event.target.value)
        }
    }

    const addDataField = () => {
        setDataFields((dataFields) => [...dataFields, { "id": v4(), "source": "", "destination": "", "FirmVendorMappingId": v4() }])
    }

    const removeDataField = (key) => {
        const newDataFields = [...dataFields]
        const index = dataFields.findIndex((i) => {
            return i.id === key;
        })
        newDataFields.splice(index, 1)
        setDataFields(newDataFields)
    }

    const handleCustomMappings = () => {
        setShowCustomMappingModal(true);
    }

    const getVendorLevelOptions = (vendorLevelOptions) => {
        if (!vendorLevelOptions || vendorLevelOptions.length <= 1) return [];
    
        return vendorLevelOptions.slice(0, -1).map((vendor, index) => ({
            value: vendor.StepNumber,
            label: `${vendor.VendorName} to ${vendorLevelOptions[index + 1].VendorName}`
        }));
    };

    const DataMappingRenderer = (props) => {
        const dataFieldIndex = props.data["id"]
        const [sourceValue, setSourceValue] = useState(props.data["source"])
        const [destinationValue, setDestinationValue] = useState(props.data["destination"])
        const [lastIndex, setLastIndex] = useState(dataFields[0]["id"])
        const updateDataField = (event, flag) => {
            if (flag === "source") {
                setSourceValue(event.target.value)
                for (let field in dataFields) {
                    if (dataFields[field]["id"] === dataFieldIndex) {
                        dataFields[field]["source"] = event.target.value
                    }
                }
            } else if (flag === "destination") {
                setDestinationValue(event.target.value)
                for (let field in dataFields) {
                    if (dataFields[field]["id"] === dataFieldIndex) {
                        dataFields[field]["destination"] = event.target.value
                    }
                }
            }
        }
        useEffect(() => {
            setLastIndex(dataFields[dataFields.length - 1]["id"])
        }, [dataFields])

        return (
            <Row className="no-gutter" style={{ padding: "0px 10px" }}>
                {
                    dataFieldIndex != "addButton" ?
                        <Row className="no-gutter" style={{ margin: "5px 0px", padding: 0 }}>
                            <Col md={6} className="flex-column-start-center" style={{ padding: "0px 15px 0px 0px" }}>
                                <input type="text" className="form-control move-left custom-input" id="exampleInputEmail1" aria-describedby="emailHelp"
                                    placeholder={'Enter custom data'}
                                    value={sourceValue}
                                    onChange={(event) => updateDataField(event, "source")}
                                    autoComplete="nope"
                                />
                            </Col>
                            <Col md={5} className="flex-column-start-center" style={{ padding: "0px 0px 0px 15px" }}>
                                <input type="text" className="form-control move-left custom-input" id="exampleInputEmail1" aria-describedby="emailHelp"
                                    placeholder={'Enter data to be mapped'}
                                    value={destinationValue}
                                    onChange={(event) => updateDataField(event, "destination")}
                                    autoComplete="nope"
                                />
                            </Col>

                            <Col md={1} className="flex-column-end-center" style={{ padding: "0px 0px 0px 10px" }}>
                                <Icon.DashCircleFill onClick={() => removeDataField(dataFieldIndex)} style={{ fontSize: 20, margin: "-8px 0px 8px 0px" }} />
                            </Col>
                        </ Row>
                        : <></>
                }
            </Row>
        )
    }

    return <>
        <Modal
            {...props}
            size="lg"
            aria-labelledby="contained-modal-title-vcenter"
            backdrop="static"
            centered
            className="mapping-modal"
            scrollable="false"
        >
            <Modal.Header className="mapping-modal-header" closeButton>
            </Modal.Header>
            <Modal.Body className="mapping-modal">
                <h5 style={{ textAlign: "center", marginBottom: 15 }}>Field Mapping&nbsp;&nbsp;
                    <OverlayTrigger
                        trigger="click"
                        placement="right"
                        overlay={popover_1}
                    >
                        <Icon.PatchQuestionFill style={{ fontSize: 10, marginTop: -5, cursor: "pointer" }} />
                    </OverlayTrigger>
                </h5>

                <Row className="no-gutter" style={{ padding: "0px 10px" }}>
                    <Col md={6} style={{ padding: "0px 15px 0px 0px" }}>
                        <div className="flex-row-space-center">
                            <span className="mapping-select-label" >Source Field 
                            <span style={{ color: 'red', fontSize: '0.8em', verticalAlign: 'super' }}>*</span>
                            </span>
                            <div className="pivot-check-holder" style={{ float: "right" }}>
                                <label style={{ marginLeft: 5, fontSize: 10, fontWeight: 700 }}>
                                    Custom?
                                </label>
                                <input type="checkbox" className={"form-check-input move-left custom-check-input"} checked={customSourceCheck}
                                    onChange={(event) => setCustomSourceCheck(event.target.checked)}
                                />
                            </div>
                        </div>
                        {
                            customSourceCheck
                                ?
                                <input type="text" className="form-control move-left custom-input"
                                    placeholder={'Enter custom data'}
                                    value={customSourceField}
                                    onChange={(event) => updateCustomDataField(event, "source")}
                                    autoComplete="nope"
                                />
                                :
                                <Select
                                    options={OptionRenderer(sourceEndPoints)}
                                    value={sourceField}
                                    aria-label="Default"
                                    closeMenuOnSelect={true}
                                    autosize={true}
                                    placeholder="Select source field"
                                    menuPosition="fixed"
                                    // defaultValue={sourceField}
                                    onChange={setSourceField}
                                    // isLoading={isSelectOptionsLoading}
                                    className='custom-select '
                                    classNamePrefix="react-select"
                                />
                        }
                    </Col>
                    <Col md={6} style={{ padding: "0px 0px 0px 15px" }}>
                        <div className="flex-row-space-center">
                            <span className="mapping-select-label">Destination Field
                            <span style={{ color: 'red', fontSize: '0.8em', verticalAlign: 'super' }}>*</span>
                             </span>
                            <div className="pivot-check-holder">
                                <label style={{ marginLeft: 5, fontSize: 10, fontWeight: 700 }}>
                                    Custom
                                </label>
                                <input type="checkbox" className={"form-check-input move-left custom-check-input"} checked={customDestinationCheck}
                                    onChange={(event) => setCustomDestinationCheck(event.target.checked)}
                                />
                            </div>
                        </div>
                        {
                            customDestinationCheck
                                ?
                                <input type="text" className="form-control move-left custom-input"
                                    placeholder={'Enter custom data'}
                                    value={customDestinationField}
                                    onChange={(event) => updateCustomDataField(event, "destination")}
                                    autoComplete="nope"
                                />
                                :
                                <Select
                                    options={OptionRenderer(targetEndPoints)}
                                    value={destinationField}
                                    aria-label="Default"
                                    closeMenuOnSelect={true}
                                    autosize={true}
                                    placeholder="Select destination field"
                                    menuPosition="fixed"
                                    // defaultValue={destinationField}
                                    onChange={setDestinationField}
                                    // isLoading={isSelectOptionsLoading}
                                    className='custom-select'
                                    classNamePrefix="react-select"
                                />
                        }
                    </Col>
                </Row>
                <Row className="no-gutter" style={{ padding: "10px 10px 0px 10px" }}>
                    <Col md={12} style={{ padding: "0px 0px 0px 0px" }}>
                        <div className="flex-row-space-center">
                            <span className="mapping-select-label" >Format </span>
                            <div className="pivot-check-holder" style={{ float: "right" }}>
                                <label style={{ marginLeft: 5, fontSize: 10, fontWeight: 700 }}>
                                    Custom
                                </label>
                                <input type="checkbox" className={"form-check-input move-left custom-check-input"} checked={customFormatCheck}
                                    onChange={(event) => setCustomFormatCheck(event.target.checked)}
                                />
                            </div>
                        </div>
                        {
                            customFormatCheck
                                ?
                                <input type="text" className="form-control move-left custom-input"
                                    placeholder={'Enter custom data'}
                                    value={fieldFormat}
                                    onChange={(event) => setFieldFormat(event.target.value)}
                                    autoComplete="nope"
                                />
                                :
                                <Select
                                    options={OptionRenderer([fieldFormat])}
                                    value={fieldFormat}
                                    aria-label="Default"
                                    closeMenuOnSelect={true}
                                    autosize={true}
                                    placeholder="Select field format"
                                    menuPosition="fixed"
                                    // defaultValue={destinationField}
                                    onChange={setFieldFormat}
                                    // isLoading={isSelectOptionsLoading}
                                    className='custom-select'
                                    classNamePrefix="react-select"
                                />
                        }
                    </Col>
                </Row>
                <Col md={6} style={{ marginTop: 10 }}>
                    <span style={{ marginLeft: 10 }} className="mapping-select-label">Level</span>
                </Col>
                <Row className="no-gutter" style={{ padding: 0 }}>
                    <Select
                        options={getVendorLevelOptions(props.vendorleveloptions)}
                        value={flowStepNumber}
                        aria-label="Default"
                        closeMenuOnSelect={true}
                        autosize={true}
                        placeholder="Select level"
                        menuPosition="fixed"
                        onChange={(selectedOption) => setFlowStepNumber(selectedOption)}
                        className='custom-select'
                        classNamePrefix="react-select"
                    />
                </Row>
                <Row className="no-gutter flex-row-space-center" style={{ margin: "20px 0px 10px 0px" }}>
                    <Col md={3}></Col>
                    <Col md={8} style={{ textAlign: "center" }}>
                        <h5 style={{ textAlign: "center", width: "fit-content" }}>Custom Data Mapping &nbsp;&nbsp;
                            <OverlayTrigger
                                trigger="click"
                                placement="right"
                                overlay={popover_2}
                            >
                                <Icon.PatchQuestionFill style={{ fontSize: 10, marginTop: -5, cursor: "pointer" }} />
                            </OverlayTrigger>
                        </h5>
                    </Col>
                    <Col md={1} style={{ padding: "0px 5px 0px 5px" }}>
                        <Icon.PlusCircleFill onClick={() => addDataField()} style={{ fontSize: 20 }} />
                    </Col>
                </Row>
                <Row className="no-gutter" style={{ padding: 0 }}>
                    {dataFields.length > 0 ?
                        <>
                            <Col md={6}>
                                <span className="mapping-select-label">Source Data </span>
                            </Col>
                            <Col md={6} style={{paddingLeft: 15}}>
                                <span className="mapping-select-label">Destination Data </span>
                            </Col>
                        </> : <></>
                    }
                </Row>
                {
                    dataFields.map((data) => (
                        <DataMappingRenderer
                            data={data}
                        />
                    ))
                }
            </Modal.Body>
            <Modal.Footer className="action-footer">
                <Button className={ "superadmin-button" } style={{float: "left"}}
                    onClick={() => handleCustomMappings()}
                >
                    Show Cygnus Custom Mappings
                </Button>
                <Button onClick={() => saveDataMapping(props)} className={!apiInProgress ? "superadmin-button" : "apiInProgress"}
                    disabled={
                        !(sourceField || customSourceField) || !(destinationField || customDestinationField)
                    }
                    >{!apiInProgress ? "Add" :
                    <>Add &nbsp;
                        <ThreeCircles
                            height="20"
                            width="20"
                            color="#4fa94d"
                            wrapperStyle={{}}
                            wrapperClass=""
                            visible={true}
                            ariaLabel="three-circles-rotating"
                            outerCircleColor="var(--theme1_primary)"
                            innerCircleColor="var(--theme1_secondary)"
                            middleCircleColor="var(--theme1_tertiary)"
                        />
                    </>}</Button>
            </Modal.Footer>
        </Modal>
                    
        <CygnusCustomMappingModal
            show={showCustomMappingModal}
            sourceVendor={"XCM"}
            destinationVendor={"Cygnus Dashboard"}
            onHide={() => setShowCustomMappingModal(false)}
            flowId={1}
      />

    </>
}